export const I18nPrefix = 'i18n';